import { useCurrentUserStore } from '@/stores/currentUser';
import { useTeamStore } from '@/stores/team';
import type { RouteLocationNormalizedGeneric } from 'vue-router';

export const useRouter = () => {
  const user = useCurrentUserStore();
  const teamStore = useTeamStore();

  const loadUserWhenNeeded = async ({ toPage }: { toPage: RouteLocationNormalizedGeneric }) => {
    if (!user.isInitialized && !toPage.meta?.skipLoadUser) {
      await Promise.all([user.initialize(), teamStore.reloadTeam()]);
    }
  };

  const hasAccess = ({ toPage }: { toPage: RouteLocationNormalizedGeneric }) => {
    if (toPage.path.startsWith('/admin')) {
      return user.isInternalAdmin();
    }

    return true;
  };

  return { loadUserWhenNeeded, hasAccess };
};
